module.exports = __webpack_public_path__ + "static/media/django.386b4464.jpg";